/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetProductTypesOutputDTO } from '../model';
/**
 * ProductTypeApi - axios parameter creator
 * @export
 */
export const ProductTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all product types.
         * @summary Get Product Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTypesDockschedulingProductTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dockscheduling/product-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTypeApi - functional programming interface
 * @export
 */
export const ProductTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all product types.
         * @summary Get Product Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductTypesDockschedulingProductTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductTypesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductTypesDockschedulingProductTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductTypeApi - factory interface
 * @export
 */
export const ProductTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductTypeApiFp(configuration)
    return {
        /**
         * Get all product types.
         * @summary Get Product Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTypesDockschedulingProductTypesGet(options?: any): AxiosPromise<GetProductTypesOutputDTO> {
            return localVarFp.getProductTypesDockschedulingProductTypesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductTypeApi - object-oriented interface
 * @export
 * @class ProductTypeApi
 * @extends {BaseAPI}
 */
export class ProductTypeApi extends BaseAPI {
    /**
     * Get all product types.
     * @summary Get Product Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTypeApi
     */
    public getProductTypesDockschedulingProductTypesGet(options?: any) {
        return ProductTypeApiFp(this.configuration).getProductTypesDockschedulingProductTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}
